import { Pipe, PipeTransform } from '@angular/core';
import { AngularFirestore, Query } from '@angular/fire/firestore';
import { StudiesService } from '@app/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TrackItemType } from '../enums';
@Pipe({
  name: 'getFireDoc',
})
export class GetFireDocPipe implements PipeTransform {
  trackItemType = TrackItemType;
  constructor(private store: AngularFirestore, private studiesService: StudiesService) {}

  transform(userId?: string, collection?: string, uuid?: string, type?: string, ...args: unknown[]): Observable<any> {
    let studyId = this.studiesService.getStudyId();
    if (type === this.trackItemType.SURVEY) {
      return this.getSurvey(studyId, userId, collection, uuid);
    }

    if (type === this.trackItemType.TEST) {
      return this.getCognitives(studyId, userId, collection, uuid);
    }

    if (type === this.trackItemType.FITBIT) {
      return this.getFitbit(userId, collection);
    }

    if (type === this.trackItemType.HEALTHKIT) {
      return this.getHealthKit(userId, collection);
    }

    if (type === this.trackItemType.ACTIVITY) {
      return this.getActivityLogs(userId, collection);
    }

    if (type === this.trackItemType.SLEEP) {
      return this.getSleepLog(userId, collection);
    }
  }

  private getSurvey(studyId: string, userId: string, collection: string, uuid: string): Observable<any> {
    return this.store
      .collection(collection, (ref) => {
        let query: Query = ref;
        if (userId) {
          query = query.where('userId', '==', userId);
        }
        if (studyId) {
          query = query.where('studyId', '==', studyId);
        }
        if (uuid) {
          query = query.where('surveyId', '==', uuid);
        }
        return query;
      })
      .valueChanges()
      .pipe(map((item: any[]) => (item.length > 0 ? item.pop() : null)));
  }

  private getCognitives(studyId: string, userId: string, collection: string, uuid: string): Observable<any> {
    return this.store
      .collection(collection, (ref) => {
        let query: Query = ref;
        if (userId) {
          query = query.where('userId', '==', userId);
        }
        if (studyId) {
          query = query.where('studyId', '==', studyId);
        }
        if (uuid) {
          query = query.where('cognitiveId', '==', uuid);
        }
        return query;
      })
      .valueChanges()
      .pipe(map((item: any[]) => (item.length > 0 ? item.pop() : null)));
  }

  private getFitbit(userId: string, collection: string): Observable<any> {
    return this.store.collection(collection).doc(userId).valueChanges();
  }

  private getHealthKit(userId: string, collection: string): Observable<any> {
    return this.store.collection(collection).doc(userId).valueChanges();
  }

  private getActivityLogs(userId: string, collection: string): Observable<any> {
    return this.store.collection(collection).doc(userId).collection('values').valueChanges();
  }

  private getSleepLog(userId: string, collection: string): Observable<any> {
    return this.store.collection(collection).doc(userId).collection('values').valueChanges();
  }
}
